/**
 * Define the `ANNOTATION` action name, used when an annotation is (de)selected
 * in TinyMCE.
 *
 * @since 3.11.0
 * @type {string}
 */
export const ANNOTATION = "ANNOTATION";

/**
 * Define the `TOGGLE_ENTITY` action name, used when the selection state of an
 * an entity must be toggled on / off.
 *
 * @since 3.11.0
 * @type {string}
 */
export const TOGGLE_ENTITY = "TOGGLE_ENTITY";

/**
 * Define the `UPDATE_OCCURRENCES_FOR_ENTITY` action name, used to catch
 * `updateOccur(r)encesForEntity` events from the legacy Angular application.
 *
 * @since 3.11.0
 * @type {string}
 */
export const UPDATE_OCCURRENCES_FOR_ENTITY = "UPDATE_OCCURRENCES_FOR_ENTITY";

/**
 * Define the `TOGGLE_LINK` action name, used to enable/disable linking an
 * entity.
 *
 * @since 3.11.0
 * @type {string}
 */
export const TOGGLE_LINK = "TOGGLE_LINK";

/**
 * Define the `RECEIVE_ANALYSIS_RESULTS` action name, fired when analysis
 * results are received.
 *
 * @since 3.11.0
 * @type {string}
 */
export const RECEIVE_ANALYSIS_RESULTS = "RECEIVE_ANALYSIS_RESULTS";

/**
 * Define the `SET_CURRENT_ENTITY` action name, fired to edit an entity inline.
 *
 * @since 3.11.0
 * @type {string}
 */
export const SET_CURRENT_ENTITY = "SET_CURRENT_ENTITY";

export const SET_ENTITY_FILTER = "SET_ENTITY_FILTER";

/**
 * Define the `EDITOR_SELECTION_CHANGED` action name, fired when the selection has changed
 * in the main editor.
 *
 * @since 3.18.4
 * @type {string}
 */
export const EDITOR_SELECTION_CHANGED = "EDITOR_SELECTION_CHANGED";

export const TOGGLE_LINK_SUCCESS = "TOGGLE_LINK_SUCCESS";

export const ADD_ENTITY = "ADD_ENTITY";
